import * as React from 'react'
import { MessagePushNotificationFieldConnected } from './MessagePushNotificationFieldConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const MessagePushNotificationFieldExamples = () => {
  return (
    <div className="MessagePushNotificationFieldExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <MessagePushNotificationFieldConnected />
      </Provider>
    </div>
  )
}
